@if (isEditing) {
  <main class="container my-5">
    <section id="profile">
      <div class="container d-flex justify-content-center align-items-center min-vh-100 pt-5">
        <form class="w-100 pt-2">
          <div class="container-fluid main-content col-lg-8 col-md-10 col-12">
            <app-partner-form (formSubmitted)="onPartnerFormSubmitted($event)" [partner]="partner"></app-partner-form>
          </div>
        </form>
      </div>
    </section>
  </main>
} @else {
  <div class="container mt-5 pt-5 col-lg-10 col-md-10 col-12" *ngIf="partnerLoaded;else notLoaded">
    <div class="custom-card-large">
      <div class="d-flex justify-content-end mb-3">
        <button *ngIf="!partner.isDeleted  && !isDeleting" class="btn btn-primary delete-btn" (click)="deletePartner()"
                style="padding-bottom: 3px;">
           <span class="material-symbols-outlined">
                delete
           </span>
        </button>

        <button *ngIf="partner.isDeleted && (teacherRole === 'admin')"
                class="btn btn-primary delete-btn"
                (click)="undeletePartner()">
          Undelete
        </button>
      </div>

      <div class="d-flex flex-column align-items-center text-center">
        <div class="mb-3">
          <img src="{{partner.logo || 'assets/placeholderimg/partner8.jpg'}}"
               class="img-fluid mb-2 rounded border border-white" style="max-width: 6.25rem;" alt="Company Logo">
        </div>

        <div>
          <h2 class="custom-card-title">{{ partner.org }}</h2>
          <h3 class="custom-card-title">{{ partner.primeContact }}</h3>
          <h5><a href="{{partner.website}}" target="_blank">{{ partner.website }}</a></h5>
          <p class="card-text fw-normal">{{ partner.bio }}</p>
          <p class="card-text fw-normal">
            Created At: {{ partner.createdAt?.toDate() | date:'short' || 'N/A' }} -
            Modified At: {{ partner.modifiedAt?.toDate() | date:'short' || 'N/A' }}
          </p>
          <p>Created By: {{partner.createdBy}}</p>
          <p>Updated By: {{partner.modifiedBy}}</p>
        </div>
      </div>


      <div class="mt-5 d-grid gap-4 gap-md-5"
           style="grid-template-columns: 1fr; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));">
        <div class="d-flex flex-column align-items-center">
          <h2 class="custom-card-title">Project Focus Area</h2>
          <ul class="">
            <li class="fw-normal" *ngFor="let service of partner.focusAreas">{{ service }}</li>
          </ul>
        </div>

        <div class="d-flex flex-column align-items-center">
          <h2 class="custom-card-title">Services Offered</h2>
          @if (partner.servicesOffered.length > 0) {
            <ul class="">
              <li class="fw-normal" *ngFor="let service of partner.servicesOffered">{{ service }}</li>
            </ul>
          } @else {
            <p>This partner doesn't offer any services.</p>
          }

        </div>
      </div>

      <div class="mt-5 d-grid gap-4 gap-md-5"
           style="grid-template-columns: 1fr; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));">
        <div class="d-flex flex-column align-items-center">
          <h2 class="custom-card-title">Contact</h2>
          <ul class="">
            <li class="fw-normal">Email: <a href="mailto:{{partner.contactEmail}}">{{ partner.contactEmail }}</a></li>
            <li class="fw-normal">Phone: {{ formatPhone(partner.contactPhone) }}</li>
          </ul>
        </div>

        <div class="d-flex flex-column align-items-center">
          <h2 class="custom-card-title">Cost</h2>
          <ul class="">
            <li class="fw-normal">Title One Discount: {{ partner.titleOneDiscount }}</li>
            <li class="fw-normal">Standard Cost: ${{ partner.cost }}.00</li>
          </ul>
        </div>
      </div>


      <div class="justify-content-center text-center mt-4">
        <div *ngIf="teacherRole?.toLowerCase() === 'admin'" class="mt-4">
          <div *ngIf="isRecycled;else notRecycled">
            <div class="d-flex justify-content-center gap-3 flex-column flex-md-row">
              <button class="btn btn-primary w-100 w-md-25" (click)="unrecyclePartner()">
                Make Active
              </button>
            </div>
          </div>


          <ng-template #notRecycled>
            <div class="d-flex justify-content-center gap-3 flex-column flex-md-row">
              <a routerLink="/find-partners" class="btn btn-primary w-25">Return To List View</a>
              <button *ngIf="teacherRole?.toLowerCase() === 'admin'" class="btn btn-primary w-25" (click)="editPartner()">Edit</button>
              <button *ngIf="isApproved && teacherRole?.toLowerCase() === 'admin'" class="btn btn-primary w-25"
                      (click)="unapprovePartner()">Unapprove
              </button>

              <button *ngIf="!isApproved && teacherRole?.toLowerCase() === 'admin'" class="btn btn-primary w-25"
                      (click)="approvePartner()">Approve
              </button>
              <button *ngIf="!isApproved && teacherRole?.toLowerCase() === 'admin'" class="btn btn-primary w-25"
                      (click)="recyclePartner()">Make Inactive
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
}


<!-- Layout 2 -->
<div class="container mt-5 pt-5 col-lg-10 col-md-10 col-12 text-center" *ngIf="partnerLoaded">

</div>


<ng-template #notLoaded>
  <div class="container mt-5 pt-5 col-lg-10 col-me-10 col-12 text-center">
    <div class="custom-card-large">
      <h2>You do not have access to this page.</h2>
    </div>
  </div>
</ng-template>
